<template>
  <div class="result mb-4" v-if="result">
    <ResultHeader
      :result="result"
      :hours="hours"
      :dates="dates"
      :shortOrt="shortOrt"
      :freePlaces="freePlaces"
      :veranstalter="veranstalter"
    />
    <div class="pt-4 pb-5 px-3">
      <div class="mb-3">
        <h3 class="h5" style="text-transform: none;">{{ result.sembez }}</h3>
        <div class="h6">{{ result.mname1 }}</div>
      </div>
      <div class="row gx-4">
        <div class="col-12 col-md-6 resultinfo_right">
          <div class="containesr">
            <div class="row mb-2">
              <div class="col-lg-4 col-12 label fw-bold h6">Veranstaltungsart:</div>
              <div class="col-lg-8 col-12">{{ veranart }}</div>
           </div>
           <div class="row mb-2">
               <div class="col-lg-4 col-12 label fw-bold h6">Veranstaltungsort:</div>
              <div class="col-lg-8 col-12">{{ longOrt }}</div>
            </div>
             <div class="row mb-2" v-if="veranstalter != 'Fremdveranstaltung'">
               <div class="col-lg-4 col-12 label fw-bold h6">Gebühren:</div>
              <div class="col-lg-8 col-12">{{ gebuehren }}</div>
            </div>
            <div class="row mb-2" v-if="duration">
               <div class="col-lg-4 col-12 label fw-bold h6">Stunden:</div>
              <div class="col-lg-8 col-12">{{ duration }} Stunden</div>
           </div>
          </div>
        </div>
        <div class="col-12 col-md-6 position-relative resultinfo_left">
         <div class="containesr">
           <div class="row mb-2">
              <div class="col-lg-4 col-12 label fw-bold h6">Zielgruppen(n):</div>
              <div class="col-lg-8 col-12">{{ zielGruppen }}</div>
           </div>
          </div>
          <div
            class="position-absolute bottom-0 l-0 d-lg-flex justify-content-end buttons-wrapper"
          >
            <div class="mb-3 mb-md-0">
              <button
                class="btn bg-green d-block d-lg-inline-block ms-0 ms-md-2"
                data-bs-toggle="modal"
                :data-bs-target="bsTarget"
              >
                DETAILS <span class="sr-only">für {{ ariaLabel }}</span> 
              </button>
            </div>
            <a
            v-if="url"
              :href="url"
              target="_blank"
              class="btn bg-darkblue d-inline-block ms-0 ms-md-2 no-wrap"
              >VERANSTALTUNG BUCHEN<span class="sr-only">: {{ result.sembez }}</span></a
            >
          </div>
          <div v-if="!url" class="mt-3">
              <b>Diese Veranstaltung kann nicht über das Portal der Apothekerkammer Berlin gebucht werden. Bitte wenden Sie sich an den Veranstalter.</b>
            </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade modal-fullscreen modal-xl"
      :id="modalId"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="position-absolute top-0 end-0 m-2" style="z-index: 10">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body p-3">
            <ResultHeader
              :result="result"
              :hours="hours"
              :dates="dates"
              :shortOrt="shortOrt"
              :freePlaces="freePlaces"
              :veranstalter="veranstalter"
            />
            <div class="row gx-4 my-4 px-3">
              <div class="col-12 pt-1 pb-4">
                <h3>{{ result.sembez }}</h3>
                <h4>{{ result.mname1 }}</h4>
              </div>
              <div class="col-12 col-md-6 resultinfo_right">
                <table class="">
                  <tr>
                    <td class="label">Veranstaltungsart:</td>
                    <td>{{ veranart }}</td>
                  </tr>
                  <tr>
                    <td class="label">Veranstaltungsort:</td>
                    <td>{{ longOrt }}</td>
                  </tr>
                  <tr v-if="veranstalter != 'Fremdveranstaltung'">
                    <td class="label">Gebühren:</td>
                    <td>{{ gebuehren }}</td>
                  </tr>
                  <tr v-if="veranstalter != 'Fremdveranstaltung'">
                    <td class="label">Anmeldefrist:</td>
                    <td>{{ anmeldeFrist }}</td>
                  </tr>

                  <tr v-if="result.referenten.length">
                    <td class="label">Referierende(n):</td>
                    <td>
                      <div
                        v-for="referent in result.referenten"
                        :key="referent"
                      >
                        {{ referent }}
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-12 col-md-6 position-relative resultinfo_left">
                <table class="">
                  <tr>
                    <td class="label">Zielgruppen(n):</td>
                    <td>{{ zielGruppen }}</td>
                  </tr>
                  <tr v-if="duration">
                    <td class="label">Stunden:</td>
                    <td>{{ duration }} Stunden</td>
                  </tr>
                  <tr>
                    <td class="label">Punkte:</td>
                    <td>{{ result.anz_pkt }}</td>
                  </tr>
                  <tr>
                    <td class="label">Veranstaltungsnr.:</td>
                    <td>{{ result.semnr }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="mx-2 my-3">
              <a
              v-if="url"
                :href="url"
                target="_blank"
                class="btn bg-darkblue d-inline-block"
                >VERANSTALTUNG BUCHEN<span class="sr-only">: {{ result.sembez }}</span></a
              >
              <div v-if="!url">
                <b>Diese Veranstaltung kann nicht über das Portal der Apothekerkammer Berlin gebucht werden. Bitte wenden Sie sich an den Veranstalter.</b>
                </div>
              <div v-for="content in contentOrdered" :key="content.headline">
                <div v-if="content?.inhalt?.length > 5" class="mx-2 my-5">
                  <h5>{{ content.headline }}</h5>
                  <div v-html="content.inhalt" class="pre-wrap"/>
                </div>
              </div>
              <a
                v-if="contentLength > 1 && url"
                :href="url"
                target="_blank"
                class="btn bg-darkblue d-inline-block"
                >VERANSTALTUNG BUCHEN<span class="sr-only">: {{ result.sembez }}</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  returnDateString,
  parseHourStr,
  decimalHourToTime,
  debugLog,
} from "@/shared/utils";
import { defineProps } from "vue";
import ResultHeader from "@/components/Veranstaltungen/ResultHeader";

const props = defineProps({
  result: Object,
});
const { result } = props;
const time = result.sebes;

const shortOrt = result.vort1.length ? result.vort1 : "Online";
if (result.vort1.toLowerCase().indexOf("online") >= 0) {
  shortOrt += " / Online";
}
const longOrt = [
  result.vnam1,
  result.vname2,
  result.vstrasse,
  result.vplz + " " + result.vort1,
]
  .filter(function (element) {
    return element !== undefined && element.length > 0 && element !== " ";
  })
  .join(", ");

const gebuehren =
  result.gebuehren == "Kostenlos" ? result.gebuehren : result.gebuehren + " €";

const verArt = result.fb_kat || "X";

const zielGruppenAr = Object.keys(result?.berufsgruppen).map(
  (key) => result.berufsgruppen[key]
);
zielGruppenAr.sort();
const zielGruppen = zielGruppenAr.length ? zielGruppenAr.join(", ") : "";

const dates =
  result.sebes == result.seend
    ? returnDateString(result.sebes)
    : returnDateString(result.sebes) + " - " + returnDateString(result.seend);
let hours =
  result.vuhr !== "0,00" && result.buhr !== "0,00"
    ? parseHourStr(result.vuhr) + " - " + parseHourStr(result.buhr) + " Uhr"
    : result.vuhr !== "0,00"
    ? parseHourStr(result.vuhr) + " Uhr"
    : "";
if (returnDateString(result.sebes) !== returnDateString(result.seend)) hours = "";

const optionsUp =  (typeof options === 'undefined') ? '{"veranopts":[{"code":"-1","value":"Alle Ma\u00dfnahmen"},{"code":"1a","value":"1a) Seminar, Workshop, Praktikum"},{"code":"1b","value":"1b) Pharmazeutischer Qualit\u00e4tszirkel"},{"code":"2","value":"2) Kongress"},{"code":"3","value":"3) Live-Vortrag"}],"zielopts":[{"code":"*","value":"Alle Zielgruppen"},{"code":"01","value":"Apotheker\/in"},{"code":"02","value":"Apotheker\/in in Weiterbildung"},{"code":"03","value":"Apotheker\/in mit befristeter Berufserlaubnis"},{"code":"04","value":"PTA"},{"code":"05","value":"PTA in Ausbildung"},{"code":"06","value":"Pharmazeut\/in im Praktikum (PhiP) "},{"code":"07","value":"Pharmaziestudent\/in"},{"code":"08","value":"Pharmazieingenieur\/in"},{"code":"09","value":"Apothekerassistent\/in, Apothekenassistent\/in, pharmazeutische\/r Assistent\/in"},{"code":"12","value":"Arzt\/\u00c4rztin"},{"code":"13","value":"PKA"},{"code":"14","value":"PKA in Ausbildung "},{"code":"15","value":"Sonstige"}]}' : options;

const { veranopts, zielopts } = JSON.parse( optionsUp );
const veranartAr = result.fb_kat.split(",").map((catUp) => {
  const filteredOpts = veranopts.filter((opt) => opt.code == catUp);
  if (filteredOpts.length) return filteredOpts[0].value;
});
const veranart = veranartAr.join(", ");
const modalId = "modal-" + result.semnr;
const bsTarget = "#" + modalId;
const anmeldeFrist = returnDateString(result.anmschl);

const  decodeEntity = (str) => {
  var textarea = document.createElement('textarea');
  textarea.innerHTML = str.replaceAll("&#xD;&#xA;", "\n");
  return textarea.value;
}

const contentOrdered = Object.keys(result.inhalte)
  .sort()
  .map((key) => {
    return({
      headline: result.inhalte[key].headline,
      inhalt: decodeEntity(result.inhalte[key].inhalt)
    })
  });


let contentLength = 0;
contentOrdered.forEach((content) => {
  if (content?.inhalt?.length > 5) contentLength++;
});

const veranstalter =
  result?.semart == "2000" && result.semuart == "2001"
    ? "Fremdveranstaltung"
    : "Apothekerkammer";

const regEnd = new Date(result?.anmschl);

let freePlaces =
  parseInt(result.anzahl_teilnehmer) < parseInt(result.hoecht)
    ? "free"
    : "full";
if (
  freePlaces == "free" &&
  parseInt(result.anzahl_teilnehmer) > parseInt(result.hoecht) * 0.66
)
  freePlaces = "limited";
if (new Date(result?.anmschl) < new Date()) freePlaces = "full";
if (veranstalter == "Fremdveranstaltung") freePlaces = "external";

const duration = decimalHourToTime(result.lgstd);

let url = result.inhalte[17]?.inhalt || result.url;
if(veranstalter != "Fremdveranstaltung") url = result.url;

const prefix = 'https://';
if (url.substr(0, prefix.length) !== prefix)
{
    url = prefix + url;
}
if(veranstalter == "Fremdveranstaltung" && !result.inhalte[17]?.inhalt){
  url = false;
}

const ariaLabel = "Veranstaltung: " + result.sembez;
</script>

<style></style>
